/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const pastEndDate = (selectedSubscription) => {
    const isIndefiniteDate = selectedSubscription?.endDate?.includes('Indefinite');
    const isPastDate = new Date(selectedSubscription?.endDate) < new Date();
    return !isIndefiniteDate && isPastDate;
};

export default pastEndDate;
